import { useState, useEffect, useCallback } from 'react';
import {
  getGamificationProfile,
  updateGamificationProfile,
  type GamificationProfile,
  type ProfileRole,
} from '../lib/api';

export type { GamificationProfile };

export function useProfile() {
  const [profile, setProfile] = useState<GamificationProfile | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchProfile = useCallback(async () => {
    try {
      const data = await getGamificationProfile();
      setProfile(data);
    } catch {
      // ignore — profile unavailable without valid token
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  const updateBio = useCallback(
    async (bio: string) => {
      const data = await updateGamificationProfile({ bio });
      setProfile(data);
    },
    [],
  );

  const updateRole = useCallback(
    async (selectedRole: ProfileRole | '') => {
      const data = await updateGamificationProfile({ selected_role: selectedRole });
      setProfile(data);
    },
    [],
  );

  return { profile, loading, updateBio, updateRole, refetch: fetchProfile };
}
